import { createOutlinedGroup, mirrorX } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P, Pivot, R, Segments, SharedColors } from "apparatus/library/common";
import { CIRCULAR_RATIO } from "apparatus/library/transportation/osmosis_tube";
import { Group, Path } from "paper";
const RED_NORTH_COLOR = "#f12a2a";
const BLUE_SOUTH_COLOR = "#1482f5";
const GREEN_SOUTH_COLOR = "#66df44";
export class Magnet {
    render(appearance) {
        switch (appearance.shape) {
            case "horseshoe": return this.renderHorseshoe(appearance);
            case "bar": return this.renderBar(appearance);
        }
    }
    renderBar(appearance) {
        const northPole = new Path.Rectangle(R(0, 0, 45, 22, Pivot.CENTER_RIGHT))
            .withGradientFill("right-down", Gradients.cylinder(RED_NORTH_COLOR.color()));
        const southPole = new Path.Rectangle(R(0, 0, 45, 22, Pivot.CENTER_LEFT))
            .withGradientFill("right-down", Gradients.cylinder(southColor(appearance).color()));
        const graphic = createOutlinedGroup("default", SharedColors.stroke, northPole, southPole);
        graphic.scale(appearance.scale);
        return {
            graphic,
            hitShape: graphic.bounds.toShape()
        };
    }
    renderHorseshoe(appearance) {
        const thickness = 18;
        const halfShape = [
            [[0, 90 - thickness], , [CIRCULAR_RATIO * (40 - thickness), 0]],
            [[40 - thickness, 50], [0, CIRCULAR_RATIO * (40 - thickness)]],
            [[40 - thickness, 0]],
            [[40, 0]],
            [[40, 50], , [0, CIRCULAR_RATIO * 40]],
            [[0, 90], [CIRCULAR_RATIO * 40, 0]]
        ];
        const southPole = new Path(Segments(...halfShape)).close();
        const northPole = southPole.clone();
        northPole.scale(-1.0, 1.0, P(0, 0));
        northPole.withGradientFill("right-down", Gradients.cylinder(RED_NORTH_COLOR.color()));
        southPole.withGradientFill("right-down", Gradients.cylinder(southColor(appearance).color()));
        const outline = new Path(Segments(...halfShape)).close().withStroke("default");
        mirrorX(outline);
        const graphic = new Group([northPole, southPole, outline]);
        graphic.scale(appearance.scale);
        return {
            graphic,
            hitShape: graphic.bounds.toShape()
        };
    }
}
Magnet.properties = {
    label: "Magnet",
    flippable: true,
    defaultAppearance: {
        shape: "bar",
        colors: "red-blue",
        scale: 1.0,
    },
    appearanceSpecs: [
        {
            spec: "radio", key: "shape", label: "Shape",
            options: [
                { value: "bar", label: "magnet.bar" },
                { value: "horseshoe", label: "Horseshoe" },
            ],
        },
        {
            spec: "radio", key: "colors", label: "Colours",
            options: [
                { value: "red-blue", label: "Red / Blue" },
                { value: "red-green", label: "Red / Green" },
            ],
        },
        {
            spec: "slider", key: "scale", label: "Scale",
            min: 0.5, max: 3.0, step: 0.01, unit: "%"
        }
    ],
};
function southColor(appearance) {
    switch (appearance.colors) {
        case "red-blue": return BLUE_SOUTH_COLOR;
        case "red-green": return GREEN_SOUTH_COLOR;
    }
}
